<div class="flex h-full">
  <!-- Sidebar -->
<div kendoWindowContainer ></div>
<div kendoDialogContainer></div>
  <div class="w-64 shadow-md flex-shrink-0 h-full overflow-y-auto">
    <div *ngIf="editRep?.shortName" class="px-4 py-3 mb-2 border-b border-gray-200 dark:border-gray-700 bg-blue-50 dark:bg-[#1e293b]">
      <div class="text-lg font-semibold truncate" [title]="editRep.shortName">
        {{ editRep.shortName }}
      </div>
    </div>
    <kendo-buttongroup
      selection="single"
      look="flat"
      class="vertical-button-group"
    >
      <button
        kendoButton
        [toggleable]="true"
        selected="true"
        class="vertical-button"
        (click)="switchSection(repSectionEnum.Details)"
      >
        Details
      </button>
      <button
        kendoButton
        [toggleable]="true"
        class="vertical-button"
        [disabled]="action == actionEnum.Add"
        (click)="switchSection(repSectionEnum.Assistant)"
      >
        Assistant
      </button>
      <button
        kendoButton
        [toggleable]="true"
        class="vertical-button"
        [disabled]="action == actionEnum.Add"
        (click)="switchSection(repSectionEnum.BdStates)"
      >
        BD States
      </button>
      <button
        kendoButton
        [toggleable]="true"
        class="vertical-button"
        [disabled]="action == actionEnum.Add"
        (click)="switchSection(repSectionEnum.IaStates)"
      >
        IA States
      </button>
      <button
        kendoButton
        [toggleable]="true"
        class="vertical-button"
        [disabled]="action == actionEnum.Add"
        (click)="switchSection(repSectionEnum.License)"
      >
        License
      </button>
      <button
        kendoButton
        [toggleable]="true"
        class="vertical-button"
        [disabled]="action == actionEnum.Add"
        (click)="switchSection(repSectionEnum.Log)"
      >
        Log
      </button>
      <button
        kendoButton
        [toggleable]="true"
        class="vertical-button"
        [disabled]="action == actionEnum.Add"
        (click)="switchSection(repSectionEnum.PersonalAccounts)"
      >
        Personal Accounts
      </button>
      <button
        kendoButton
        [toggleable]="true"
        class="vertical-button"
        [disabled]="action == actionEnum.Add"
        (click)="switchSection(repSectionEnum.OutsideActivity)"
      >
        Outside Activity
      </button>
      <button
        kendoButton
        [toggleable]="true"
        class="vertical-button"
        [disabled]="action == actionEnum.Add"
        (click)="switchSection(repSectionEnum.Professional)"
      >
        Professional
      </button>
      <button
        kendoButton
        [toggleable]="true"
        class="vertical-button"
        [disabled]="action == actionEnum.Add"
        (click)="switchSection(repSectionEnum.Registration)"
      >
        Registration
      </button>
      <button
        kendoButton
        [toggleable]="true"
        class="vertical-button"
        [disabled]="action == actionEnum.Add"
        (click)="switchSection(repSectionEnum.RepCodes)"
      >
        Rep Codes
      </button>
      <button
        kendoButton
        [toggleable]="true"
        class="vertical-button"
        [disabled]="action == actionEnum.Add"
        (click)="switchSection(repSectionEnum.SocialMedia)"
      >
        Social Media
      </button>
      <button
        kendoButton
        [toggleable]="true"
        class="vertical-button"
        [disabled]="action == actionEnum.Add"
        (click)="switchSection(repSectionEnum.Solicitor)"
      >
        Solicitor
      </button>
      <button
        kendoButton
        [toggleable]="true"
        class="vertical-button"
        [disabled]="action == actionEnum.Add"
        (click)="switchSection(repSectionEnum.Subscription)"
      >
        Subscription
      </button>
    </kendo-buttongroup>
  </div>
  <!-- Main Content -->
  <div class="flex-1 p-6 overflow-auto">
    <div [ngSwitch]="currentSection" class="switch-wrapper">
      <div *ngSwitchCase="repSectionEnum.Details">
        <form
          class="editor-form k-form-horizontal"
          [formGroup]="editorForm"
          (ngSubmit)="onSubmit($event)"
          *ngIf="editorForm"
        >
          <div class="shadow-sm rounded-lg flex flex-col mb-6">
            <div class="px-4 py-3 border-b border-gray-200 dark:border-gray-700 font-medium text-gray-700 dark:text-white">Rep Info</div>
            <div class="p-4 flex-grow editor-card mt-2"  >
              <div class="flex flex-cols-3">
                <kendo-formfield [orientation]="'horizontal'">
                  <label class="input-label">First Name:</label>
                  <input
                    class="input"
                    type="text"
                    name="firstName"
                    formControlName="firstName"
                    maxlength="50"
                    kendoTextBox
                    required
                  />
                  <kendo-formerror>First Name is required</kendo-formerror>
                </kendo-formfield>
                <kendo-formfield [orientation]="'horizontal'">
                  <label class="input-label">Middle Name:</label>
                  <input
                    class="input"
                    type="text"
                    name="middleName"
                    formControlName="middleName"
                    kendoTextBox
                    maxlength="50"
                  />
                </kendo-formfield>
                <kendo-formfield [orientation]="'horizontal'">
                  <label class="input-label">Last Name:</label>
                  <input
                    class="input"
                    type="text"
                    name="lastName"
                    formControlName="lastName"
                    kendoTextBox
                    maxlength="100"
                    required
                  />
                  <kendo-formerror>Last Name is required</kendo-formerror>
                </kendo-formfield>
                <kendo-formfield [orientation]="'horizontal'">
                  <label class="input-label">Short Name:</label>
                  <input
                    class="input"
                    type="text"
                    name="shortName"
                    formControlName="shortName"
                    kendoTextBox
                    maxlength="100"
                  />
                </kendo-formfield>
                <kendo-formfield [orientation]="'horizontal'">
                  <label class="input-label">Title:</label>
                  <input
                    class="input"
                    type="text"
                    name="title"
                    formControlName="title"
                    kendoTextBox
                    maxlength="100"
                  />
                </kendo-formfield>
              </div>
              <div class="flex flex-cols-3">
                <kendo-formfield [orientation]="'horizontal'">
                  <label class="input-label">Date of Birth:</label>
                  <kendo-datepicker
                    class="input"
                    type="date"
                    name="dob"
                    formControlName="dob"
                    activeView="year"
                    placeholder="01/05/2000"
                    [focusedDate]="defaultDateOfBirth"
                    (valueChange)="calculatePrimaryAge($event)"
                  ></kendo-datepicker>
                  <label>{{calculatedAge}}</label>
                </kendo-formfield>
                <kendo-formfield [orientation]="'horizontal'">
                  <label class="input-label">SSN:</label>
                  <kendo-maskedtextbox
                    class="input"
                    type="text"
                    name="ssn"
                    formControlName="ssn"
                    [mask]="ssnMask"
                    maxlength="50"
                  ></kendo-maskedtextbox>
                </kendo-formfield>
                <kendo-formfield [orientation]="'horizontal'">
                  <label class="input-label">Email Address:</label>
                  <input
                    class="input"
                    type="text"
                    name="email"
                    formControlName="email"
                    kendoTextBox
                    required
                    maxlength="100"
                  />
                  <kendo-formerror *ngIf="editorForm.controls.email.touched"
                    >Invalid Email Address</kendo-formerror
                  >
                </kendo-formfield>
                <kendo-formfield [orientation]="'horizontal'">
                  <label class="input-label">Web Address:</label>
                  <input
                    class="input"
                    type="text"
                    name="webAddress"
                    formControlName="webAddress"
                    kendoTextBox
                    maxlength="100"
                  />
                </kendo-formfield>
                <kendo-formfield [orientation]="'horizontal'">
                  <label class="input-label">Insurance Rep:</label>
                  <input
                    class="input"
                    type="text"
                    name="insRepName"
                    formControlName="insRepName"
                    kendoTextBox
                  />
                </kendo-formfield>
              </div>
              <div class="flex flex-cols-3">
                <kendo-formfield [orientation]="'horizontal'">
                  <label class="input-label">Hire Date:</label>
                  <kendo-datepicker
                    class="input"
                    type="date"
                    name="hireDate"
                    formControlName="hireDate"
                  >
                  </kendo-datepicker>
                </kendo-formfield>
                <kendo-formfield [orientation]="'horizontal'">
                  <label class="input-label">Termination Date:</label>
                  <kendo-datepicker
                    class="input"
                    type="date"
                    name="terminationDate"
                    formControlName="terminationDate"
                  >
                  </kendo-datepicker>
                </kendo-formfield>
                <kendo-formfield [orientation]="'horizontal'">
                  <label class="input-label">CRD Number:</label>
                  <input
                    class="input"
                    type="text"
                    name="crdnumber"
                    formControlName="crdnumber"
                    kendoTextBox
                    maxlength="10"
                  />
                </kendo-formfield>
                <kendo-formfield [orientation]="'horizontal'">
                  <label class="input-label">CRD Branch #:</label>
                  <kendo-dropdownlist
                    class="input"
                    [defaultItem]="defaultCrdBranchNumber"
                    [data]="lookups.orderedCrdBranchNumbers"
                    [itemDisabled]="itemDisabled"
                    name="branchNumber"
                    formControlName="branchNumber"
                    required
                  ></kendo-dropdownlist>
                  <kendo-formerror>CRD Branch # is required</kendo-formerror>
                </kendo-formfield>
              </div>
              <div class="flex checkbox-row">
                <div>
                  <input
                    type="checkbox"
                    name="brokerRep"
                    formControlName="brokerRep"
                    kendoCheckBox
                  />
                  <label class="checkbox-label">Broker Rep</label>
                </div>
                <div>
                  <input
                    type="checkbox"
                    name="bankRep"
                    formControlName="bankRep"
                    kendoCheckBox
                  />
                  <label class="checkbox-label">Bank Rep</label>
                </div>
                <div>
                  <input
                    type="checkbox"
                    name="accessPerson"
                    formControlName="accessPerson"
                    kendoCheckBox
                  />
                  <label class="checkbox-label">Access Person</label>
                </div>
                <div>
                  <input
                    type="checkbox"
                    name="doNotPrint"
                    formControlName="doNotPrint"
                    kendoCheckBox
                  />
                  <label class="checkbox-label">Do Not Print</label>
                </div>
                <div>
                  <input
                    type="checkbox"
                    name="notProducer"
                    formControlName="notProducer"
                    kendoCheckBox
                  />
                  <label class="checkbox-label">Not Producer</label>
                </div>
                <div>
                  <input
                    type="checkbox"
                    name="receiveAlerts"
                    formControlName="receiveAlerts"
                    kendoCheckBox
                  />
                  <label class="checkbox-label">Receive Alerts</label>
                </div>
                <div>
                  <input
                    type="checkbox"
                    name="receiveApprovals"
                    formControlName="receiveApprovals"
                    kendoCheckBox
                  />
                  <label class="checkbox-label">Receive Approvals</label>
                </div>
              </div>
            </div>
          </div>
          <div class="shadow-sm rounded-lg flex flex-col mb-6">
            <div class="px-4 py-3 border-b border-gray-200 dark:border-gray-700 font-medium text-gray-700 dark:text-white">Contact Info</div>
            <div class="p-4 flex-grow editor-card mt-2">
              <div class="flex flex-cols-2">
                <div class="col-header space-below">Work Address:</div>
                <kendo-formfield [orientation]="'horizontal'">
                  <label class="input-label">Street 1:</label>
                  <input
                    class="input"
                    type="text"
                    name="workAddress1"
                    formControlName="workAddress1"
                    kendoTextBox
                    maxlength="255"
                  />
                </kendo-formfield>
                <kendo-formfield [orientation]="'horizontal'">
                  <label class="input-label">Street 2:</label>
                  <input
                    class="input"
                    type="text"
                    name="workAddress2"
                    formControlName="workAddress2"
                    kendoTextBox
                    maxlength="255"
                  />
                </kendo-formfield>
                <kendo-formfield [orientation]="'horizontal'">
                  <label class="input-label">City:</label>
                  <input
                    class="input"
                    type="text"
                    name="workCity"
                    formControlName="workCity"
                    kendoTextBox
                    maxlength="50"
                  />
                </kendo-formfield>
                <kendo-formfield [orientation]="'horizontal'">
                  <label class="input-label">State:</label>
                  <kendo-dropdownlist
                    class="input"
                    [defaultItem]="defaultState"
                    [data]="lookups.stateList"
                    [valuePrimitive]="true"
                    textField="stateText"
                    valueField="stateValue"
                    name="workState"
                    formControlName="workState"
                  ></kendo-dropdownlist>
                </kendo-formfield>
                <kendo-formfield [orientation]="'horizontal'">
                  <label class="input-label">Zip:</label>
                  <input
                    class="input"
                    type="text"
                    name="workZip"
                    formControlName="workZip"
                    kendoTextBox
                    maxlength="10"
                  />
                </kendo-formfield>
                <div class="col-header">Home Address:</div>
                <kendo-formfield [orientation]="'horizontal'">
                  <label class="input-label">Street 1:</label>
                  <input
                    class="input"
                    type="text"
                    name="homeAddress1"
                    formControlName="homeAddress1"
                    kendoTextBox
                    maxlength="255"
                  />
                </kendo-formfield>
                <kendo-formfield [orientation]="'horizontal'">
                  <label class="input-label">Street 2:</label>
                  <input
                    class="input"
                    type="text"
                    name="homeAddress2"
                    formControlName="homeAddress2"
                    kendoTextBox
                    maxlength="255"
                  />
                </kendo-formfield>
                <kendo-formfield [orientation]="'horizontal'">
                  <label class="input-label">City:</label>
                  <input
                    class="input"
                    type="text"
                    name="homeCity"
                    formControlName="homeCity"
                    kendoTextBox
                    maxlength="50"
                  />
                </kendo-formfield>
                <kendo-formfield [orientation]="'horizontal'">
                  <label class="input-label">State:</label>
                  <kendo-dropdownlist
                    class="input"
                    [defaultItem]="defaultState"
                    [data]="lookups.stateList"
                    [valuePrimitive]="true"
                    textField="stateText"
                    valueField="stateValue"
                    name="homeState"
                    formControlName="homeState"
                  ></kendo-dropdownlist>
                </kendo-formfield>
                <kendo-formfield [orientation]="'horizontal'">
                  <label class="input-label">Zip:</label>
                  <input
                    class="input"
                    type="text"
                    name="homeZip"
                    formControlName="homeZip"
                    kendoTextBox
                    maxlength="10"
                  />
                </kendo-formfield>
              </div>
              <div class="flex flex-cols-2">
                <div class="col-header">Mail Address:</div>
                <kendo-formfield [orientation]="'horizontal'">
                  <label class="input-label">Same as Work Address</label>
                  <input
                    type="checkbox"
                    name="sameAsWorkAddress"
                    [formControl]="sameAsWorkAddress"
                    kendoCheckBox
                  />
                </kendo-formfield>
                <kendo-formfield [orientation]="'horizontal'">
                  <label class="input-label">Street 1:</label>
                  <input
                    class="input"
                    type="text"
                    name="mailAddress1"
                    formControlName="mailAddress1"
                    kendoTextBox
                    maxlength="255"
                  />
                </kendo-formfield>
                <kendo-formfield [orientation]="'horizontal'">
                  <label class="input-label">Street 2:</label>
                  <input
                    class="input"
                    type="text"
                    name="mailAddress2"
                    formControlName="mailAddress2"
                    kendoTextBox
                    maxlength="255"
                  />
                </kendo-formfield>
                <kendo-formfield [orientation]="'horizontal'">
                  <label class="input-label">City:</label>
                  <input
                    class="input"
                    type="text"
                    name="mailCity"
                    formControlName="mailCity"
                    kendoTextBox
                    maxlength="50"
                  />
                </kendo-formfield>
                <kendo-formfield [orientation]="'horizontal'">
                  <label class="input-label">State:</label>
                  <kendo-dropdownlist
                    class="input"
                    [defaultItem]="defaultState"
                    [data]="lookups.stateList"
                    [valuePrimitive]="true"
                    textField="stateText"
                    valueField="stateValue"
                    name="mailState"
                    formControlName="mailState"
                  ></kendo-dropdownlist>
                </kendo-formfield>
                <kendo-formfield [orientation]="'horizontal'">
                  <label class="input-label">Zip:</label>
                  <input
                    class="input"
                    type="text"
                    name="mailZip"
                    formControlName="mailZip"
                    kendoTextBox
                    maxlength="10"
                  />
                </kendo-formfield>
                <div class="col-header">Phone:</div>
                <kendo-formfield [orientation]="'horizontal'">
                  <label class="input-label">Phone:</label>
                  <kendo-maskedtextbox
                    class="input"
                    type="text"
                    name="workPhone"
                    formControlName="workPhone"
                    [mask]="phoneMask"
                    maxlength="18"
                  ></kendo-maskedtextbox>
                </kendo-formfield>
                <kendo-formfield [orientation]="'horizontal'">
                  <label class="input-label">Extension:</label>
                  <input
                    class="input"
                    type="text"
                    name="workExt"
                    formControlName="workExt"
                    kendoTextBox
                    maxlength="50"
                  />
                </kendo-formfield>
                <kendo-formfield [orientation]="'horizontal'">
                  <label class="input-label">Home:</label>
                  <kendo-maskedtextbox
                    class="input"
                    type="text"
                    name="homePhone"
                    formControlName="homePhone"
                    [mask]="phoneMask"
                    maxlength="18"
                  ></kendo-maskedtextbox>
                </kendo-formfield>
                <kendo-formfield [orientation]="'horizontal'">
                  <label class="input-label">Mobile:</label>
                  <kendo-maskedtextbox
                    class="input"
                    type="text"
                    name="mobilePhone"
                    formControlName="mobilePhone"
                    [mask]="phoneMask"
                    maxlength="255"
                  ></kendo-maskedtextbox>
                </kendo-formfield>
                <kendo-formfield [orientation]="'horizontal'">
                  <label class="input-label">Fax:</label>
                  <kendo-maskedtextbox
                    class="input"
                    type="text"
                    name="fax"
                    formControlName="fax"
                    [mask]="phoneMask"
                    maxlength="255"
                  ></kendo-maskedtextbox>
                </kendo-formfield>
              </div>
            </div>
          </div>
          <div class="flex mb-6">
            <div class="shadow-sm rounded-lg flex flex-col flex-1">
              <div class="px-4 py-3 border-b border-gray-200 dark:border-gray-700 font-medium text-gray-700 dark:text-white">Fees</div>
              <div class="p-4 flex-grow">
                <div class="flex-cols-add3">
                  <kendo-label
                    labelCssClass="input-label"
                    text="FINRA RIA Fee:"
                  ></kendo-label>
                  <kendo-numerictextbox
                    [format]="'n2'"
                    class="input"
                    name="adminFee"
                    formControlName="adminFee"
                  ></kendo-numerictextbox>
                </div>
                <div class="flex-cols-add3">
                  <kendo-label
                    labelCssClass="input-label"
                    text="FINRA Branch Fee:"
                  ></kendo-label>
                  <kendo-numerictextbox
                    [format]="'n2'"
                    class="input"
                    name="nasdbranchFee"
                    formControlName="nasdbranchFee"
                  ></kendo-numerictextbox>
                </div>
                <div class="flex-cols-add3">
                  <kendo-label
                    labelCssClass="input-label"
                    text="FINRA Annual Fee:"
                  ></kendo-label>
                  <kendo-numerictextbox
                    [format]="'n2'"
                    class="input"
                    name="nasdannualFee"
                    formControlName="nasdannualFee"
                  ></kendo-numerictextbox>
                </div>
              </div>
            </div>
             <div class="shadow-sm rounded-lg flex flex-col flex-1">
              <div class="p-4 flex-grow flex space-x-2">
                <button
                  kendoButton
                  themeColor="primary"
                  class="form-button"
                  type="submit"
                  [disabled]="!editorForm.valid || !isAdmin"
                >
                  Save
                </button>
                <button 
                  kendoButton
                  themeColor="info"
                  type="button"
                  class="form-button"
                  (click)="goToMembership($event)"
                  *ngIf="currentRepId && isAdmin"
                >
                  <span *ngIf="editRep?.hasUser">Edit Membership</span>
                  <span *ngIf="!editRep?.hasUser">Grant Web Access</span>
                </button>
                <button
                  kendoButton
                  themeColor="light"
                  class="form-button"
                  (click)="goToViewReps()"
                >
                  Back to View
                </button>
              </div>
            </div>
          </div>

           
        </form>
      </div>
      <gd-rep-editor-assistant
        *ngSwitchCase="repSectionEnum.Assistant"
        [repId]="currentRepId"
      >
      </gd-rep-editor-assistant>
      <gd-rep-editor-ia-states
        *ngSwitchCase="repSectionEnum.IaStates"
        [repId]="currentRepId"
      ></gd-rep-editor-ia-states>
      <gd-rep-editor-bd-states
        *ngSwitchCase="repSectionEnum.BdStates"
        [repId]="currentRepId"
      ></gd-rep-editor-bd-states>
      <gd-rep-editor-license
        *ngSwitchCase="repSectionEnum.License"
        [repId]="currentRepId"
      ></gd-rep-editor-license>
      <gd-rep-editor-log
        *ngSwitchCase="repSectionEnum.Log"
        [repId]="currentRepId"
      ></gd-rep-editor-log>
      <gd-rep-editor-personal-accounts
        *ngSwitchCase="repSectionEnum.PersonalAccounts"
        [repId]="currentRepId"
      >
      </gd-rep-editor-personal-accounts>
      <gd-rep-editor-outside-activity
        *ngSwitchCase="repSectionEnum.OutsideActivity"
        [repId]="currentRepId"
      >
      </gd-rep-editor-outside-activity>
      <gd-rep-editor-professional
        *ngSwitchCase="repSectionEnum.Professional"
        [repId]="currentRepId"
      >
      </gd-rep-editor-professional>
      <gd-rep-editor-registration
        *ngSwitchCase="repSectionEnum.Registration"
        [repId]="currentRepId"
      >
      </gd-rep-editor-registration>
      <gd-rep-editor-rep-codes
        *ngSwitchCase="repSectionEnum.RepCodes"
        [repId]="currentRepId"
      ></gd-rep-editor-rep-codes>
      <gd-rep-editor-social-media
        *ngSwitchCase="repSectionEnum.SocialMedia"
        [repId]="currentRepId"
      >
      </gd-rep-editor-social-media>
      <gd-rep-editor-solicitor
        *ngSwitchCase="repSectionEnum.Solicitor"
        [repId]="currentRepId"
      >
      </gd-rep-editor-solicitor>
      <gd-rep-editor-subscription
        *ngSwitchCase="repSectionEnum.Subscription"
        [repId]="currentRepId"
      >
      </gd-rep-editor-subscription>
    </div>
  </div>
</div>
